import Router from 'next/router';

const initAutoScrollRestoration = () => {
    const cachedScrollOffset = [];
    let scrollY = 0;

    Router.events.on('routeChangeStart', () => {
        cachedScrollOffset.push(window.scrollY);
    });

    Router.events.on('routeChangeComplete', () => {
        window.scrollTo(0, scrollY);
        scrollY = 0;
    });

    Router.beforePopState(() => {
        scrollY = cachedScrollOffset.pop();
        return true;
    });
};

export {initAutoScrollRestoration};
